"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.charterIndexTheme = void 0;
const palette_1 = require("./palette");
exports.charterIndexTheme = {
    palette: palette_1.charterIndexPalette,
    typography: {
        h1: {
            fontWeight: 'bold',
            fontSize: '3.75rem',
        },
        h2: {
            fontWeight: 'bold',
            fontSize: '2rem',
        },
        h3: {
            fontWeight: 'bold',
            fontSize: '1.5rem',
        },
        h4: {
            fontWeight: 'bold',
        },
        h5: {
            fontWeight: 'bolder',
        },
        body1: {
            fontSize: '1.2rem',
        },
        body2: {
            fontSize: '1rem',
        },
        button: {
            textTransform: 'none',
            whiteSpace: 'nowrap',
            fontSize: '1.1rem',
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: 'contained',
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
    },
};
//# sourceMappingURL=theme.js.map